import { useIntl } from 'react-intl';
import { Icon } from 'src/components';
import { msgs } from './messages';
import * as S from './styles';

type MemriseTeamBannerProps = { className?: string };

export const MemriseTeamBanner = ({ className }: MemriseTeamBannerProps) => {
  const intl = useIntl();

  return (
    <S.MemriseTeamBanner className={className} data-testid="memriseTeamBanner">
      <S.LogoContainer>
        <Icon name="memrise" />
      </S.LogoContainer>

      {intl.formatMessage(msgs.byMemriseLinguistTeam)}
    </S.MemriseTeamBanner>
  );
};
